<template>
	<div class="Home">
		<Banner />
		
		<div class="HomeInner">
			<Publicidad />
			<Novedades />
			<NovedadesCarousel />
		</div>

		<VideosHome />

		<Contacto />
	</div>
</template>

<script>
import HomeModal from "./HomeModal.vue";
//import FirstCarousel from "./components/FirstCarousel.vue";
import Banner from "./components/Banner/Banner.vue";
// import GaleriaHome from "../Home/components/GaleriaHome.vue";
//import Cards from "../Home/components/Cards/Cards.vue";
import UltimosResultados from "../Home/components/Ultimos Resultados/UltimosResultados.vue";
// import NoticiasYFrecuentes from "../Home/components/Noticias y Frecuentes/NoticiasYFrecuentes.vue";
// import ComiteEjecutivo from "../Home/components/Comite Ejecutivo/ComiteEjecutivo.vue";
import VideosHome from "./VideosHome.vue";
import Contacto from "../Home/components/Contacto/Contacto.vue";
//import ABlog from "./components/BlogHomeCentral/ABlog.vue";
import Redes from "./components/Redes/Redes.vue";
import Entidades from "./components/Entidades/Entidades.vue";
import Novedades from "./components/Novedades/Novedades.vue";
import NovedadesCarousel from "./components/Novedades/NovedadesCarousel.vue";
import Publicidad from "@/components/Publicidad/Publicidad.vue";

export default {
	data: () => ({
		showModal: false,
	}),
	computed: {
		alertHomeModal() {
			return (
				this.$store.getters?.alerta_home.find(
					(item) => item.publicar === true
				) || {}
			);
		},
	},
	components: {
		// GaleriaHome,
		//Cards,
		UltimosResultados,
		Publicidad,
		// NoticiasYFrecuentes,
		// ComiteEjecutivo,
		VideosHome,
		Contacto,
		HomeModal,
		NovedadesCarousel,
		Banner,
		//FirstCarousel,
		Redes,
		Entidades,
		Novedades,
		//ABlog,
	},
	props: {
		contenido: Object,
		images: Array,
	},
	methods: {
		closeModal() {
			this.showModal = false;
		},
	},
	async beforeMount() {
		let modalVisto = this.$cookies.get("modalVisto");
		if (!modalVisto) {
			this.$cookies.set("modalVisto", true, 30);
			await this.$store.dispatch("getAlertaHome");
			if (this.$store.getters.alerta_home) {
				this.$store.getters.alerta_home.forEach((item) => {
					if (item?.publicar === true) this.showModal = true;
				});
			}
		}
	},
};
</script>

<style scoped>
.HomeInner {
	width: 100%;
	max-width: 65rem;

	margin: 0 auto;

	display: flex;
	gap: 2rem;
	flex-direction: column;
	justify-content: center;
	align-items: start;
}

@media (orientation: portrait) {
	.HomeInner {
		width: 100%;
		max-width: calc(100% - 2rem);

		padding-left: .5rem;
	}
}

</style>
